<template>
  <div class="mt-3">
    <div class="section mb-2">
      <div class="section_header mb-3">
        <div class="row no-gutters align-items-center justify-content-between">
          <div class="col">
            <h2 class="section_header_title">
              {{ titulo }}
            </h2>
          </div>
        </div>
      </div>
    </div>

    <div v-for="documento in arquivoEstruturado.documentos_falecido"
         :key="documento.tipo"
         class="container-fluid mb-3">
      <div class="row">
        <div class="col-md-3">
          <span class="text-muted">{{ tratarDados ('tipoDocumento', documento.tipo) }}</span>
        </div>

        <div v-if="documento.orgao_emissor"
             class="col-md-3">
          <span class="text-muted">Órgão emissor</span>
        </div>

        <div class="col-md-3">
          <span class="text-muted">UF emissor</span>
        </div>

        <div class="col-md-3">
          <span class="text-muted">Data emissão</span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3">
          <b class="text-break">{{ documento.documento || 'Não informado' }}</b>
        </div>

        <div v-if="documento.orgao_emissor"
             class="col-md-3">
          <b>{{ documento.orgao_emissor || 'Não informado' }}</b>
        </div>

        <div class="col-md-3">
          <b>{{ documento.uf_emissao || 'Não informado' }}</b>
        </div>

        <div class="col-md-3">
          <b>{{ tratarDados ('dataEmissao', documento.data_emissao ) }}</b>
        </div>
      </div>
    </div>
    
    <div class="container-fluid">
      <div class="row gx-4">
        <div class="col-md-3">
          <label class="text-muted mb-1">Deixa bens</label>
          <p><b>{{ tratarDados ('boolean', arquivoEstruturado.deixou_bens ) }}</b></p>
        </div>

        <div class="col-md-3">
          <label class="text-muted mb-1">Deixa testamento</label>
          <p><b>{{ tratarDados ('boolean', arquivoEstruturado.testamento ) }}</b></p>
        </div>

        <div class="col-md-3">
          <label class="text-muted mb-1">Eleitor ativo</label>
          <p><b>{{ tratarDados ('boolean', arquivoEstruturado.era_eleitor ) }} </b></p>
        </div>

        <div class="col-md-3">
          <label class="text-muted mb-1">Herdeiros menores interditos</label>
          <p><b>{{ tratarDados ('boolean', arquivoEstruturado.herdeiros_menores_interditos ) }}</b></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Documentos',
    props: {
      arquivoEstruturado: {
        type: Object,
        default: null
      },
      titulo: {
        type: String,
        default: 'Documentos'
      }
    },
    methods: {
      tratarDados (tipo, dado) {
        if (dado === null || dado === undefined || dado === '') {
          return 'Não informado'
        }

        switch (tipo) {
        case 'tipoDocumento':
          return this.formatarTipoDocumento(dado)

        case 'dataEmissao':
          return this.formatarData(dado)

        case 'boolean':
          return this.formatarBoolean(dado)

        default:
          return dado
        }
      },
      formatarTipoDocumento (tipo) {
        const tipos = {
          cnh: 'CNH',
          certidao_nascimento: 'Certidão nascimento',
          certidao_casamento: 'Certidão casamento',
          passaporte: 'Passaporte'
        }

        if (tipos[tipo]) {
          return tipos[tipo]
        }

        return tipo.replace(/_/g, ' ')
      },
      formatarData (data) {
        return data.replace(/-/g, '/')
      },
      formatarBoolean (boolean) {
        return boolean ? 'Sim' : 'Não'
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "@/scss/_utilities/_exports";

.section {
  &_header {
    @extend %titleBox;
    background-color: $color-gray-light;

    &_title {
      @extend %titleBox_title;
    }
  }
}
.boxGenitor {
  box-shadow: 0 0 pxToRem(4) 0 $color-dark;

  &_error {
    border: solid 2px #8B0000;
    border-radius: 2px;
  }

  &_header {
    background-color: #01AEC9;
    color: $color-dark;

    &_title {
      font-size: pxToRem(14);
      font-weight: 500;
    }
  }

  &_body {
    border-right: 2px solid #DDDDDD;
    border-bottom: 2px solid #DDDDDD;
    border-radius: 0 0 8px 8px;
  }

  &_list {
    font-size: pxToRem(14);
    list-style: none;
    margin: 0;
    padding: 0;

    &_item {}

    &_title {
      margin-bottom: pxToRem(4);
      text-decoration: underline;
    }
  }
}
</style>